module.exports = __webpack_public_path__ + "static/img/AxialBase-RA.102959f.png";